import Vue from "vue";
import Axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { toData, to } from "./promiseHandle";
import { AuthenService } from "@/services/authen.service.ts";
// import { Proposal, ProposalItem } from '@/models/Coupon';
import { CommonService } from '@/services/Common.service';

export class LiftService extends Vue {
  private baseAPI = process.env.VUE_APP_API_URL;
  private commonAPI = process.env.VUE_APP_API_COMMON_URL;
  private authService = new AuthenService();
  private commonService = new CommonService();

  constructor() {
    super();
  }

  get headers() {
    return {
      "Content-Type": "application/json",
      auth: localStorage.getItem("token")
    };
  }

  public async getKyotens() {
    return this.commonService.getKyotens();
}

  public async getLifts(kyotenCd: string | null) {
    const { result, error } = await this.commonService.get(
      `${this.baseAPI}/lifts?q=kyotenCd=${kyotenCd}`
    );
    if (result) {
      return result.data;
    } else {
      return this.authService.handleError(error, "getLifts");
    }
  }

  public async deleteLift(id: number) {
    const { result, error } = await this.commonService.delete(`${this.baseAPI}/lifts/${id}`);
    if (result) {
      return result.status;
    } else {
      return this.authService.handleError(error, "deleteLift");
    }
  }
}
